export enum ResourceAllocationActionTypes {
  RESET_MONTHLY_FREE_DOWNLOAD = 'RESET_MONTHLY_FREE_DOWNLOAD'
}

export interface IResetMonthlyFreeDownloadAction {
  type: ResourceAllocationActionTypes.RESET_MONTHLY_FREE_DOWNLOAD;
}

export type ResourceAllocationActions = IResetMonthlyFreeDownloadAction;
